
const errorMsg = (apiName: string) => `max.iot.${apiName} is not supported in ${__platform} platform`
export const iot: IoTDSL = {
  executeFunction() {
    console.warn(errorMsg("executeFunction"))
  },
  exeCommands() {
    console.warn(errorMsg("exeCommands"))
    return Promise.resolve({} as IoTResponse)
  },
  setProperty() {
    console.warn(errorMsg("setProperty"))
    return Promise.resolve({} as IoTResponse)
  },
  getProperty() {
    console.warn(errorMsg("getProperty"))
    return Promise.resolve({} as IoTResponse)
  },
  queryDevice() {
    console.warn(errorMsg("queryDevice"))
    return Promise.resolve({} as IoTResponse)
  },
  addDevice() {
    console.warn(errorMsg("addDevice"))
    return Promise.resolve({} as IoTResponse)
  },
  updateDevice() {
    console.warn(errorMsg("addDevice"))
    return Promise.resolve({} as IoTResponse)
  },
  removeDevice() {
    console.warn(errorMsg("removeDevice"))
    return Promise.resolve({} as IoTResponse)
  },
  registerEvent(): any {
    console.warn(errorMsg("registerEvent"))

  },
  registerEventByType(): any {
    console.warn(errorMsg("registerEventByType"))

  },
  registerEventBySN(): any {
    console.warn(errorMsg("registerEventBySN"))

  },
  unregisterEvent() {
    console.warn(errorMsg("unregisterEvent"))
    return Promise.resolve({} as IoTResponse)

  },
  unregisterEventByType() {
    console.warn(errorMsg("unregisterEventByType"))
    return Promise.resolve({} as IoTResponse)

  },
  unregisterEventBySN() {
    console.warn(errorMsg("unregisterEventBySN"))
    return Promise.resolve({} as IoTResponse)

  },
  unregisterEventByEventId() {
    console.warn(errorMsg("unregisterEventByEventId"))
    return Promise.resolve({} as IoTResponse)

  }
}
